var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78547 15.7615C12.5694 15.3686 15.5198 12.1698 15.5198 8.28189C15.5198 4.12861 12.1529 0.761719 7.99966 0.761719C3.84639 0.761719 0.479492 4.12861 0.479492 8.28189C0.479492 11.8123 2.91227 14.7745 6.19287 15.5836V10.2018H4.86035V8.07696H6.19287V6.76265C6.19287 4.96236 7.039 3.95396 9.16341 3.95396C9.90149 3.95396 10.4417 4.06201 11.1438 4.20606L10.8201 6.24066C10.4599 6.16863 9.97351 6.11482 9.6676 6.11482C8.83928 6.11482 8.78547 6.47496 8.78547 7.05119V8.07696H10.8561L10.6756 10.2018H8.78547V15.7615Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.423d008d5c60c49c228c153971296e17.svg";
export { ForwardRef as ReactComponent };